import React from 'react'
import { useIntl } from 'react-intl'
import { Text } from '@contrast-security-inc/design-system-typography'
import { Bugtrackers, JobOutcomePolicy, Webhooks } from './common/interfaces'
import { MicrosoftTeamsIntegration } from './microsoft-teams-integration/microsoft-teams-integration'
import { SlackIntegration } from './slack-integration/slack-integration'
import { GithubIntegration } from './github-integration/github-integration'
import { AzureBoardsIntegration } from './azure-boards-integration/azure-boards-integration'
import { JiraListItem } from './jira/jira-list-item/jira-list-item'
import { AgileCentralIntegration } from './agile-central-integration/agile-central-integration'
import { PagerDutyIntegration } from './pager-duty-integration/pager-duty-integration'
import { VictorOpsIntegration } from './victor-ops-integration/victor-ops-integration'
import { GenericWebhookIntegration } from './generic-webhook-integration/generic-webhook-integration'
import { JenkinsIntegration } from './jenkins-integration/jenkins-integration'
import { CurrentOrganization } from '../current-organization'

interface IntegrationsListViewProps {
  readonly currentOrganization: CurrentOrganization
  readonly webhooks: Webhooks
  readonly bugtrackers: Bugtrackers
  readonly jobOutcomePolicy: JobOutcomePolicy
}

export const IntegrationsListView = ({
  webhooks,
  bugtrackers,
  jobOutcomePolicy
}: IntegrationsListViewProps) => {
  const intl = useIntl()

  return (
    <section className="panel panel-default table-dynamic integrations">
      <div className="panel-heading">
        <span className="panel-heading-title">
          <Text>{intl.formatMessage({ id: 'title_integrations' })}</Text>
        </span>
      </div>
      <div className="panel-body panel-body-narrow">
        <div className="panel-message">
          <p className="color-gray-middle">
            <Text>
              {intl.formatMessage({
                id: 'detail_integrationsSettings_description'
              })}
            </Text>
          </p>
        </div>
        <MicrosoftTeamsIntegration integrations={webhooks.microsoftteams} />
        <SlackIntegration integrations={webhooks.slack} />
        <GithubIntegration integrations={bugtrackers.github} />
        <AzureBoardsIntegration integrations={bugtrackers.vsts} />
        <JiraListItem integrations={bugtrackers.jira} />
        <AgileCentralIntegration integrations={bugtrackers.agileCentral} />
        <PagerDutyIntegration integrations={webhooks.pagerduty} />
        <VictorOpsIntegration integrations={webhooks.victorops} />
        <GenericWebhookIntegration integrations={webhooks.generic} />
        <JenkinsIntegration integrations={jobOutcomePolicy.jenkins} />
      </div>
    </section>
  )
}
